/**
 * Reload UK-eligible PDPs when Shopify switches market client-side (common on
 * mobile) without re-rendering Liquid. Forces one navigation to /en-gb/ so the
 * server loads tw-custom-main-product.
 */
(function () {
  var RETRY = 'tw_uk_pdp_r';
  var EN_GB_PREFIX = '/en-gb';
  var CHECK_DELAYS_MS = [0, 400, 800, 1500, 3000, 5000, 8000];
  var reloading = false;
  var historyHooked = false;

  function isEnabled() {
    return window.TW_UK_PDP_RELOAD_ENABLED === true;
  }

  function hasCustomPdp() {
    return !!document.querySelector('[data-tw-uk-custom-pdp]');
  }

  function hasRetried() {
    return new URLSearchParams(location.search).has(RETRY);
  }

  /** @param {string} pathname */
  function hasEnGbPath(pathname) {
    return (
      pathname === EN_GB_PREFIX ||
      pathname.indexOf(EN_GB_PREFIX + '/') === 0
    );
  }

  /** @returns {boolean} */
  function isUkContext() {
    if (hasEnGbPath(location.pathname)) {
      return true;
    }
    if (document.body.getAttribute('market') === 'GB') {
      return true;
    }
    if (document.documentElement.lang === 'en-GB') {
      return true;
    }

    var theme = window.theme || {};
    var localization = theme.localization || {};

    if (localization.location === 'united-kingdom') {
      return true;
    }
    if (localization.country === 'GB') {
      return true;
    }
    if (theme.locale === 'en-GB') {
      return true;
    }
    if (theme.currency === 'GBP') {
      return true;
    }

    return false;
  }

  /** @param {URL} url */
  function ensureEnGbPath(url) {
    if (hasEnGbPath(url.pathname)) {
      return url;
    }
    if (!isUkContext()) {
      return url;
    }

    url.pathname = EN_GB_PREFIX + url.pathname;
    return url;
  }

  function shouldAttemptReload() {
    if (!isEnabled()) return false;
    if (reloading) return false;
    if (hasCustomPdp()) return false;
    if (hasRetried()) return false;
    if (!isUkContext()) return false;
    return true;
  }

  function reloadForUk() {
    if (!shouldAttemptReload()) return;

    reloading = true;

    var url = ensureEnGbPath(new URL(location.href));
    url.searchParams.set(RETRY, '1');
    location.replace(url.toString());
  }

  function scheduleChecks() {
    CHECK_DELAYS_MS.forEach(function (delay) {
      setTimeout(reloadForUk, delay);
    });
  }

  function hookHistoryChanges() {
    if (historyHooked) return;
    historyHooked = true;

    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var result = original.apply(this, arguments);
        scheduleChecks();
        return result;
      };
    });

    window.addEventListener('popstate', scheduleChecks);
  }

  function watchMarketContext() {
    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(scheduleChecks);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['market'],
    });
  }

  if (!isEnabled()) return;

  hookHistoryChanges();
  watchMarketContext();
  scheduleChecks();
})();
